module.exports = __webpack_public_path__ + "static/media/pic-book-main-img.dcba2c6a.jpg";